// Default player names: a little silly on purpose, like naming a farm animal.
// Shared so the server can name CPU seats the same way the client names people.

const TITLES = [
  'Sir', 'Lady', 'Captain', 'Duchess', 'Baron', 'Professor', 'Admiral', 'Count', 'Madame', 'Lord',
  'Auntie', 'Doctor', 'Chef', 'Grandpa', 'Princess', 'Mayor', 'Old', 'Little', 'Uncle', 'Countess',
];

const ADJECTIVES = [
  'Grumpy', 'Sleepy', 'Wobbly', 'Sneaky', 'Jolly', 'Dapper', 'Soggy', 'Fancy', 'Bouncy', 'Spicy',
  'Fluffy', 'Crispy', 'Tiny', 'Mighty', 'Rumpled', 'Sparkly', 'Bashful', 'Zesty', 'Toasty', 'Wonky',
];

const NAMES = [
  'Waffles', 'Pickles', 'Biscuit', 'Noodle', 'Muffin', 'Turnip', 'Pudding', 'Sprout', 'Bramble', 'Crumpet',
  'Dumpling', 'Wiggles', 'Puddle', 'Gizmo', 'Clover', 'Marmalade', 'Toffee', 'Pebble', 'Nugget', 'Parsnip',
  'Custard', 'Scone', 'Radish', 'Truffle', 'Mittens', 'Pumpkin', 'Teacup', 'Mochi', 'Jellybean', 'Bumble',
  'Crouton', 'Gherkin', 'Waddles', 'Doodle', 'Tater', 'Kipper', 'Bean', 'Sprocket', 'Haggis', 'Pancake',
  'Fig', 'Chowder', 'Snickerdoodle', 'Gumdrop', 'Barnaby', 'Wilbur', 'Hazelnut', 'Tumbleweed', 'Cobbler', 'Pip',
];

const SURNAMES = [
  'von Crumb', 'McFluff', 'Snugglebottom', 'Puddleworth', 'the Third', 'Wobblesworth', 'of Turnipshire',
  'Fizzlewick', 'the Magnificent', 'Butterbean', 'Thistledown', 'Biscuitbeard', 'the Bold', 'of the Marsh',
  'Featherbottom', 'Mudpie', 'Crumbleton', 'the Unready', 'Honeypot', 'Bumbleworth',
];

const pick = <T>(list: readonly T[], random: () => number): T => list[Math.floor(random() * list.length)]!;

/** One whimsical name, at most 24 characters (the name limit). `random` returns [0, 1). */
export function sillyName(random: () => number = Math.random): string {
  for (;;) {
    const name = pick(NAMES, random);
    const roll = random();
    const full =
      roll < 0.3 ? `${pick(TITLES, random)} ${name}` : roll < 0.6 ? `${name} ${pick(SURNAMES, random)}` : roll < 0.85 ? `${pick(ADJECTIVES, random)} ${name}` : name;
    if (full.length <= 24) return full;
  }
}

/** A name nobody in `taken` already has (compared without case). */
export function uniqueSillyName(taken: readonly string[], random: () => number = Math.random): string {
  const used = new Set(taken.map((t) => t.toLowerCase()));
  for (let i = 0; i < 50; i++) {
    const name = sillyName(random);
    if (!used.has(name.toLowerCase())) return name;
  }
  return sillyName(random);
}
